import React from "react";
import { observer } from "mobx-react";
import { Button, Dialog } from "@material-ui/core";

import "../../styles/PopUp.scss";
import popup from '../../stores/PopupStore';

const styles = {
  popupstyle: {
    width: "100%",
  },
  popupTitle: {
    width: "100%",
  },
  iconStyle: {
    alignSelf: "center",
    marginRight: "10px",
  },
  panelStyle: {
    marginTop: "15px",
  },
};

const PopUp = observer(
  class PopUpAutorizacionDatosPersonalesComponent extends React.Component {
    hide = () => {
      popup.hidePopupAutorizacionDatosPersonales();
    };
    getTexto = () => {
      return (
        <p id="txtModal">
          De conformidad con lo dispuesto en el artículo 25 de la Ley N°21.236 sobre portabilidad financiera (""Ley de Portabilidad""), por el envío de la presente solicitud de portabilidad usted
          autoriza la ejecución de las actividades de tratamiento de datos personales necesarias para el correcto procesamiento de esta solicitud, como del proceso de portabilidad financiera que la
          misma pueda dar a lugar. La finalidad de este tratamiento será únicamente la de llevar acabo el proceso de portabilidad financiera en sus diversas etapas y fases, considerando de forma
          particular el tratamiento de datos personales contenidos y referidos en los certificados, avisos, documentos, comprobantes, notificaciones y comunicaciones que trata la Ley de Portabilidad y
          su reglamento, asi como la transferencia y transporte de dicha información entre los proveedores financieros partícipes de un proceso de portabilidad, y entre estos y sus proveedores de
          plataformas y métodos de comunicación, así como con las entidades responsables del registro y constitución de garantías reales, según corresponda. El cliente titular de datos dispondrá en
          todo momento de los derechos respecto de sus datos personales consagrados en la Ley Nº 19.628 o la normativa que en el futuro la reemplace o modifique, los que podrá ejercer ante uno o más
          proveedores financieros partícipes de la portabilidad financiera, en los términos dispuestos en la referida ley. Para efectos del procesamiento de la presente solicitud de portabilidad como
          de los demás procedimientos que impliquen intercambio o transferencia de información entre los diferentes participantes de un proceso de portabilidad financiera, el cliente toma conocimiento
          que actúará como proveedor de métodos de comunicación para tales fines la entidad Redbanc S.A., quien ejecutará por encargo y bajo las instrucciones de los respectivos proveedores
          financieros las actividades de tratamiento de datos personales que le sean encomendadas con ocasión de la prestación de sus servicios.
        </p>
      );
    };

    render() {
      const texto = this.getTexto();
      return (
        <Dialog id="modal" modal="true" open={popup.popupAutorizacionDatosPersonales.show} style={styles.popupstyle}>
          <div className="Panel" style={styles.panelStyle}>
            <div className="titlePopup">
              <div id="txtTituloModal" style={styles.popupTitle}>
                Autorización de Tratamiento de Datos Personales:
              </div>
            </div>
            <div className="boxMensaje">
              <div className="mensaje">{texto}</div>
              <div className="boxButton">
                <Button id="btnPopUp" variant="contained" color="primary" onClick={this.hide} className="btn-moradoModal" fullWidth={true}>
                  aceptar
                </Button>
              </div>
            </div>
            <div className="franjaColores">
              <div className="rojo" />
              <div className="amarillo" />
              <div className="morado" />
            </div>
          </div>
        </Dialog>
      );
    }
  }
);

//const PopUp = withStyles(styles)(PopUpMandatoComponent);
export default PopUp;
